<app-chip
    [content]="text()"
    [iconNames]="['check_icon']"
    iconSize="16x16"
    className="!inline-flex items-center rounded-2xl"
    labelClassName="!text-xs"
/>
